"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPriceBeyondThreshold = void 0;
var isPriceBeyondThreshold = function (discount, amount) {
    return amount.decimalPlaces(10).comparedTo(discount.threshold) >= 0;
};
exports.isPriceBeyondThreshold = isPriceBeyondThreshold;
